import { ChangeEvent } from "react";

import { Icon } from "@/DesignSystem/Atoms/Icons/Icon/Icon";

import styles from "./FavouriteToggle.module.scss";

import FavouriteFillIcon from "@/DesignSystem/Atoms/Icons/Types/Favourite/favourite-fill.svg";
import FavouriteRegularIcon from "@/DesignSystem/Atoms/Icons/Types/Favourite/favourite-regular.svg";

interface IFavouriteToggleProps {
    /**
     * The optional component id
     */
    id?: string;

    /**
     * The id to target in frontend tests.
     */
    dataCy?: string;

    /**
     * Indicates whether the item is marked as a favourite.
     */
    isFavourite: boolean;

    /**
     * Callback function triggered when the component is clicked.
     * @param e - The change event triggered by the input element.
     */
    onChange: (e: ChangeEvent<HTMLInputElement>) => void;
}

function FavouriteToggle({
    id,
    dataCy,
    isFavourite,
    onChange
}: Readonly<IFavouriteToggleProps>): JSX.Element {
    return (
        <label className={styles.favouriteContainer}>
            <input
                id={id}
                data-cy={dataCy}
                type="checkbox"
                checked={isFavourite}
                onChange={onChange}
                style={{ display: "none" }}
            />
            {isFavourite
                ? (
                    <Icon size="md" colorVariant="warning">
                        <FavouriteFillIcon />
                    </Icon>
                )
                : (
                    <Icon size="md" colorVariant="neutral">
                        <FavouriteRegularIcon />
                    </Icon>
                )
            }
        </label>
    );
}

export { FavouriteToggle, IFavouriteToggleProps };
